/**
 * Rebuy OOS enforcement
 *
 * Rebuy renders "recently viewed" and recommendation widgets client-side (Vue).
 * We use the official 'rebuy.ready' event (fires per-widget with its products array)
 * as the primary hook to disable ATC buttons for storefront-oos products. A
 * MutationObserver serves as a safety net for Vue re-renders that may reset button
 * state after initial enforcement. Pages without Rebuy are ignored automatically —
 * 'rebuy.loaded' and 'rebuy.ready' simply never fire.
 */
const RebuyOos = {
  init() {
    const OOS_TAG = 'storefront-oos';
    const OOS_CLASSES = ['tag-storefrontoos', 'tag-storefront-oos'];
    const BLOCK_SELECTOR = '.rebuy-product-block';
    const BTN_SELECTOR = '.rebuy-button';

    const disableBtn = (block) => {
      const btn = block.querySelector(BTN_SELECTOR);
      if (!btn || btn.disabled) return;
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = 'OUT OF STOCK';
    };

    // Primary hook: fires per-widget when Rebuy has rendered and products are ready.
    // Use product tag data directly and target the block by its product-id class.
    document.addEventListener('rebuy.ready', (event) => {
      const { products } = event.detail || {};
      if (!products) return;
      products.forEach((product) => {
        const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map(t => t.trim());
        if (!tags.includes(OOS_TAG)) return;
        const block = document.querySelector(`${BLOCK_SELECTOR}.product-id-${product.id}`);
        if (block) disableBtn(block);
      });
    });

    // Safety net: catches Vue re-renders that reset a button's disabled/text state.
    // Scoped to OOS blocks only via the CSS class Rebuy adds from the product tag.
    let rafId = null;
    const observer = new MutationObserver(() => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        document.querySelectorAll(
          OOS_CLASSES.map(cls => `${BLOCK_SELECTOR}.${cls}`).join(',')
        ).forEach(disableBtn);
      });
    });

    document.addEventListener('rebuy.loaded', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'disabled'],
      });
    }, { once: true });
  },
};

export default RebuyOos;
